class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

// <!-- This code is to modify the URL. It will add the sku into the URL -->
// <script>
//   document.addEventListener("DOMContentLoaded", function() {
//     // Check if the product object is available
//     if (typeof Shopify !== 'undefined' && Shopify.product) {
//       // Get the first variant (default variant)
//       var defaultVariant = {{ product.variants.url }};

//       // Build the new URL with the variant ID
//       var currentUrl = window.location.href;
//       var newUrl = currentUrl.split('?')[0] + '?variant=' + defaultVariant;

//       // Only update the URL if the variant is not already present
//       if (!currentUrl.includes('variant=')) {
//         history.replaceState(null, null, newUrl);
//       }
//     }
//   });
// </script>